console.log(
"OUTLINE ENGINE LOADED"
);

function applyOutline(type){

const activeLayer =
document.querySelector(
".embroidery-text-layer.active-layer"
);

if(!activeLayer) return;

activeLayer.dataset.outline =
type;

activeLayer
.querySelectorAll(".curve-letter")
.forEach(letter=>{

letter.classList.remove(
"classic-outline",
"bold-outline",
"double-outline"
);

if(type==="none") return;

letter.classList.add(
type + "-outline"
);

});

window.EMBStorage?.save();

}

document.addEventListener(
"DOMContentLoaded",
()=>{

document
.querySelectorAll(
"#outline-grid .option-card"
)
.forEach(card=>{

card.addEventListener(
"click",
()=>{

const type =
card.dataset.outline;

console.log(
"OUTLINE CLICKED",
type
);

document
.querySelectorAll(
"#outline-grid .option-card"
)
.forEach(c=>
c.classList.remove(
"active"
)
);

card.classList.add(
"active"
);

document.getElementById(
"outlineEmbroidery"
).value = type;

applyOutline(type);

}
);

});

});